module.exports = __webpack_public_path__ + "img/two_kids.66ae85f4.svg";